import React, { useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Import para idiomas
import "./wireCapabilities.css";

import logoCapabilities from "../../imagens/logos/logoWires.png";
import logoWireEn from "../../imagens/logos/logoWireEn.png";

function WireCapabilities({ listaChicotes }) {
    const { i18n, t } = useTranslation(); // Hook i18next
    const [slideNumber, setSlideNumber] = useState(0);
    const [openModal, setOpenModal] = useState(false);

    // Escolhe logo conforme idioma
    const logoImg = i18n.language === "en" ? logoWireEn : logoCapabilities;

    const handleOpenModal = (index) => {
        setSlideNumber(index);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const prevSlide = useCallback(() => {
        slideNumber === 0
            ? setSlideNumber(listaChicotes.length - 1)
            : setSlideNumber(slideNumber - 1);
    }, [slideNumber, listaChicotes.length]);

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listaChicotes.length
            ? setSlideNumber(0)
            : setSlideNumber(slideNumber + 1);
    }, [slideNumber, listaChicotes.length]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal();
                    break;
                case 'ArrowLeft':
                    prevSlide();
                    break;
                case 'ArrowRight':
                    nextSlide();
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div>
            {openModal &&
                <div className="wireSliderWrap">
                    <FontAwesomeIcon icon={faCircleXmark} className="wireBtnClose" onClick={handleCloseModal} />
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="wireBtnPrev" onClick={prevSlide} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="wireBtnNext" onClick={nextSlide} />
                    <img className="wirefullScreenImage" src={listaChicotes[slideNumber].img} alt="" />
                </div>
            }

            <div className='img-custom-size img-fluid ms-2'>
                <img src={logoImg} alt='Wire Capabilities Logo' />
            </div>

            <div className="wireGalleryWrap mx-2">
                {listaChicotes && listaChicotes.map((image, index) => (
                    <div
                        className="wireSingle"
                        key={index}
                        onClick={() => handleOpenModal(index)}
                    >
                        <img src={image.img} alt="wires" />
                    </div>
                ))}
            </div>

            <div className="text-center text-nowrap my-3">
                <Link to="/Capabilities/Production">
                    <button className="buttonCapabilities">
                        {t("wire.backToCapabilities")} {/* Texto dinâmico PT/EN */}
                    </button>
                </Link>
            </div>
        </div>
    );
}

export default WireCapabilities;
